import {InputSeparationVariant} from '../parse-input';
import React from 'react';
import {debounce} from '@genestack/ui';

const DEBOUNCE_DELAY = 500;

export function useDebouncedSeparationVariants(separationVariants: InputSeparationVariant[]) {
    const [debouncedSeparationVariants, setDebouncedSeparationVariants] =
        React.useState(separationVariants);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounceSetSeparationVariants = React.useCallback(
        debounce(
            (variants: InputSeparationVariant[]) => setDebouncedSeparationVariants(variants),
            DEBOUNCE_DELAY
        ),
        []
    );

    React.useEffect(() => {
        debounceSetSeparationVariants(separationVariants);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(separationVariants)]);

    return {debouncedSeparationVariants};
}
